import Vue from "vue";
import App from "./App.vue";
import VueTippy from "vue-tippy";

const element = document.getElementById("shopCountrySwitcher");

if (element) {
  Vue.use(VueTippy);
  Vue.config.productionTip = false;

  new Vue({
    render: createElement => {
      const context = {
        props: { ...element.dataset }
      };
      return createElement(App, context);
    }
  }).$mount("#shopCountrySwitcher");
}
